import { render, staticRenderFns } from "./TradeProcessDocumentation.vue?vue&type=template&id=b97581fe&"
import script from "./TradeProcessDocumentation.vue?vue&type=script&lang=js&"
export * from "./TradeProcessDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports